




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MomentListed } from '@/MomentListed'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'MomentListedListComponent',
  components: { Plotly, ModalWrapperComponent }
})
export default class MomentListedListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: MomentListed

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template
  public SHOW_IMAGE = true

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public getNicePossibleDecimalPriceString(number): string { return utils_topshot.getNicePossibleDecimalPriceString(number)}
  public getNicePossibleDecimalPriceStringForFMV(number): string { return utils_topshot.getNicePossibleDecimalPriceStringForFMV(number)}  

  public showLedger(momentID: number, serial: number) {
    (this.$refs.MomentActivityFeedComponent as ModalWrapperComponent).show(`⏳ Serial #${serial} Timeline`, 'lg', { momentID: momentID })
  }

  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
